import { Entity, Column, PrimaryColumn } from "typeorm";

@Entity("facilityassets")
export class FacilityAssets {
  @PrimaryColumn()
  Id: string;
  @Column({ nullable: false })
  Assets: string;
}